import styled from 'styled-components';

export const MenuWrapper = styled.div`
  position: relative;
`;

export const MenuDropdownWrapper = styled.div<{ isShow: boolean }>`
  visibility: ${(props) => (props.isShow ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.isShow ? '1' : '0')};
  transition:
    visibility 0.4s,
    opacity 0.4s;
  padding-top: 4px;
  position: absolute;
`;
